import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { ICONS } from 'components/Icons';
import { Button } from 'components/chroma';
import { MotorFullPageProps, MotorInsuranceType } from 'scenes/motor/types';

const ExchangeImage = styled.img`
  margin-right: 0.4rem;
`;

export const SwitchOptionsLink: FunctionComponent<
  Pick<MotorFullPageProps, 'onInsuranceTypeSwitch'> & {
    thirdPartySelected: boolean;
  }
> = ({ thirdPartySelected, onInsuranceTypeSwitch }) => (
  <Button
    tertiary
    margin={{ top: 0, left: 0, bottom: 2 }}
    onClick={() =>
      onInsuranceTypeSwitch(
        thirdPartySelected
          ? MotorInsuranceType.Comprehensive
          : MotorInsuranceType.ThirdParty
      )
    }
  >
    <ExchangeImage
      src={ICONS.CORE.EXCHANGE}
      tabIndex={-1}
      alt="Exchange cover options"
    />
    {`View ${
      thirdPartySelected ? 'Comprehensive quote' : 'Third Party quotes'
    }`}
  </Button>
);

export default SwitchOptionsLink;
